/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConnectionTestResult } from './ConnectionTestResult';
import {
    ConnectionTestResultFromJSON,
    ConnectionTestResultFromJSONTyped,
    ConnectionTestResultToJSON,
    ConnectionTestResultToJSONTyped,
} from './ConnectionTestResult';

/**
 * 
 * @export
 * @interface ResponseConnectionTestResult
 */
export interface ResponseConnectionTestResult {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseConnectionTestResult
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseConnectionTestResult
     */
    message?: string;
    /**
     * 
     * @type {ConnectionTestResult}
     * @memberof ResponseConnectionTestResult
     */
    data?: ConnectionTestResult;
}

/**
 * Check if a given object implements the ResponseConnectionTestResult interface.
 */
export function instanceOfResponseConnectionTestResult(value: object): value is ResponseConnectionTestResult {
    return true;
}

export function ResponseConnectionTestResultFromJSON(json: any): ResponseConnectionTestResult {
    return ResponseConnectionTestResultFromJSONTyped(json, false);
}

export function ResponseConnectionTestResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseConnectionTestResult {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ConnectionTestResultFromJSON(json['data']),
    };
}

export function ResponseConnectionTestResultToJSON(json: any): ResponseConnectionTestResult {
    return ResponseConnectionTestResultToJSONTyped(json, false);
}

export function ResponseConnectionTestResultToJSONTyped(value?: ResponseConnectionTestResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ConnectionTestResultToJSON(value['data']),
    };
}

